import { CapacitorPlatformAdapter } from '@/platform/capacitor/CapacitorPlatformAdapter';
import { PlatformAdapter } from '@/platform/types';
import { WebPlatformAdapter } from '@/platform/web/WebPlatformAdapter';

export function getPlatformAdapter(): PlatformAdapter {
  const isCapacitor = typeof window !== 'undefined' && 'Capacitor' in window;

  return isCapacitor ? new CapacitorPlatformAdapter() : new WebPlatformAdapter();
}
